import { Ptag } from "components/core";
import React, { useMemo } from "react";
import {
  BackgroundAbstraction,
  CoverageDetailsCard,
  CoverageDetailsCardHeader,
  // Grid,
  CustomGrid,
  ProductDetailCardWrapper,
  ProductFooter,
} from "../styles";
import { Divider } from "@mui/material";
import ProductDetailCardDependents from "./DependentsView";
import {
  formatDateYYYY,
  formatNumberToIndian,
  getProductBgAbstractionImg,
  getProductDescription,
} from "utlis/utils";
import QuickLinks from "../QuickLinks";
import { useNavigate } from "react-router";
import EndorsementCard from "./EndorsementCard";
import ClaimsView from "./ClaimsView";
import BaseLinkButton from "components/core/BaseLinkButton";
import { FLEX_PRODUCTS } from "pages/FlexSetup/constants";

function ProductDetailCard({ product, productKey, showClaims }) {
  const isWelless = useMemo(() => {
    return [
      "FITNESS",
      "MENTAL_WELLBEING",
      "DOCTOR_CONSULTATION",
      "HEALTH_CHECKUP",
      "DENTAL",
    ].includes(productKey);
  }, [productKey]);

  const navigate = useNavigate();
  const quickLinks = useMemo(() => {
    const links = [];
    if (product?.userplan_data?.flat_or_graded !== "PER_EMPLOYEE") {
      if (isWelless) {
        const wellnessName = FLEX_PRODUCTS.find((pr) => pr.value == productKey)?.display_name;
        console.log({ wellnessName });
        links.push({
          title: "View Plan Setup",
          callback: () => {
            navigate(`/v1/wellness/setup/summary-post/${product?.benefit_id}?name=${wellnessName}`);
          },
        });
      } else {
        links.push({
          title: "View Plan Setup",
          callback: () => {
            navigate(`/v1/plan-overview/${product.userplan}`);
          },
        });
      }
    }
    if (product?.userplan_data?.policy_doc_url) {
      links.push({
        title: "View Policy Schedule",
        url: product?.userplan_data?.policy_doc_url,
      });
    }
    if (product?.userplan_data?.employee_policy_doc_url) {
      links.push({
        title: "View Benefit Manual",
        url: product?.userplan_data?.employee_policy_doc_url,
      });
    }
    if (product?.userplan_data?.network_hospital_url) {
      links.push({
        title: "Network Hospital",
        url: product?.userplan_data?.network_hospital_url,
      });
    }
    if (
      [
        "health_insurance",
        "health_insurance_additional",
        "top_up_health",
        "parental_cover",
      ].includes(productKey)
    ) {
      links.push({
        title: "Claims Support",
        callback: () => {
          navigate(
            `/v1/claim-support?userplan=${product?.userplan}&product=${productKey}`
          );
        },
      });
    }
    return links;
  }, [product]);

  const isOnlyEmployees = useMemo(() => {
    if (
      product.dependents_allowed_union.length === 1 &&
      product.dependents_allowed_union[0] === "Employee"
    ) {
      return true;
    }
    return false;
  }, [product]);

  return (
    <ProductDetailCardWrapper
      initial={{
        opacity: 0,
        y: -10,
      }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
    >
      <Ptag color="#4A4A4A" fontSize="14px" marginBottom="34px">
        {getProductDescription(product, productKey)}
      </Ptag>
      <CustomGrid>
        <CoverageDetailsCard
          style={{
            gridColumn: "1/5",
            gridRow: isWelless ? "1/3" : "1/2",
            padding: "36px 48px 36px 24px",
          }}
        >
          <CoverageDetailsCardHeader isOnlyEmployees={isOnlyEmployees}>
            <Ptag color="#4A4A4A" fontSize="16px" fontWeight="600">
              Total {isOnlyEmployees ? "Employees" : "Lives"}
            </Ptag>
            <Ptag color="#4A4A4A" fontSize="20px" fontWeight="700">
              {formatNumberToIndian(product.no_of_lives)}
            </Ptag>
          </CoverageDetailsCardHeader>
          {!isOnlyEmployees && (
            <>
              <Divider
                sx={{
                  borderColor: "#00000012",
                  margin: "16px 0px",
                }}
              />
              <ProductDetailCardDependents
                dependents={product.dependent_wise_count}
              />
            </>
          )}
          {!isWelless && (
            <ProductFooter
              style={{
                marginTop: isOnlyEmployees ? "-20px" : "32px",
              }}
            >
              <BaseLinkButton label="View All" path="/v1/employee-mis" />
            </ProductFooter>
          )}
        </CoverageDetailsCard>
        <QuickLinks
          title="Links"
          links={quickLinks}
          style={{
            gridColumn: "5/-1",
            gridRow: "1/3",
          }}
        />
        {!isWelless && (
          <>
            <CoverageDetailsCard style={{ gridColumn: "1/3" }}>
              <Ptag color="#646075" marginBottom="14px">
                Policy ID
              </Ptag>
              <Ptag fontWeight="600" fontSize="16px">
                {product?.userplan_data?.group_policy_number??'-'}
              </Ptag>
            </CoverageDetailsCard>
            <CoverageDetailsCard style={{ gridColumn: "3/5" }}>
              <Ptag color="#646075" marginBottom="14px">
                Policy Period
              </Ptag>
              <Ptag fontWeight="600" fontSize="16px">
                {formatDateYYYY(
                  product?.userplan_data?.subscription?.start_date
                )}{" "}
                -{" "}
                {formatDateYYYY(product?.userplan_data?.subscription?.end_date)}
              </Ptag>
            </CoverageDetailsCard>
            <EndorsementCard userplanId={product?.userplan} />
          </>
        )}
        {["health_insurance", "health_insurance_additional"].includes(
          productKey
        ) &&
          showClaims && <ClaimsView />}
      </CustomGrid>
      <BackgroundAbstraction
        src={getProductBgAbstractionImg(productKey)}
        alt=""
      />
    </ProductDetailCardWrapper>
  );
}

export default ProductDetailCard;
